import React, { useEffect, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label, { DisplayLabel } from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Float from "../ui/Float";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { bm_date, drawNote, drawPOSStatus } from "../utils/Utils";
import DateInput from "../ui/DateInput";

export default function OrdersDetails(props) {

    const { controller = "", selected = {}, setSelected = () => { }, items = [], setItems = () => { }, selectedItem = {}, setSelectedItem = () => { } } = props;
    const [data, setData] = useState({});


    return (
        <div className="pos-card" style={{ "height": "260px", "overflow": "hidden" }}>
            <div className="shim" />
            <div style={{ "display": 'flex', "gap": "20px" }}>
                <div style={{ "flex": "1" }}>
                    <Float>
                        <Space>
                            <Label width={39}>Stat</Label>
                            <Input width={80} value={selected?.status} edit></Input>
                        </Space>
                        <Space>
                            <DateInput width={100} value="PEND" edit />
                            <Label width={39}>Can</Label>
                            <Input width={100} value="" edit></Input>
                        </Space>
                    </Float>
                    <div className="shim" />
                    <Space>
                        <Label width={39}>Qty</Label>
                        <Input width={35} value="1" right edit></Input>
                    </Space>
                    <div className="shim" />
                    <Space>
                        <Label width={39}>ISBN</Label>
                        <Input width={160} value={selected?.primary_code} edit></Input>
                    </Space>

                    <div className="shim" />
                    <Space>
                        <Label width={39}>ISBN</Label>
                        <Input width={160} value={selected?.primary_code} edit></Input>
                    </Space>

                </div>
                <div style={{ "backgroundColor": "#f00", flex: "1" }}>
                    d
                </div>
            </div>
            <pre><small>{JSON.stringify(selected, null, 2)}</small></pre>

        </div>
    )
}